<template>
  <div class="p-3">
    <p><strong>Barcode:</strong> {{ selectedRepair?.barcode }}</p>
    <p><strong>Asset Name:</strong> {{ selectedRepair?.assetName }}</p>
    <p><strong>Fault:</strong> {{ selectedRepair?.fault }}</p>
    <p><strong>Logged Date:</strong> {{ selectedRepair?.logDate }}</p>
    <p><strong>Logged By:</strong> {{ selectedRepair?.logPerson }}</p>
  </div>
</template>

<script setup></script>